import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import styles from './styles.module.css'
import { orbData } from './OrbField'

const getConnectedTechNames = (connections) => {
  if (!connections || !connections.length) return []
  
  return connections.map(id => {
    const connectedTech = orbData.find(orb => orb.id === id)
    return connectedTech ? connectedTech.title : `Unknown (${id})`
  })
}

export const Modal = ({ isOpen, onClose, content, animation }) => {
  const modalRef = useRef()
  const contentRef = useRef()

  useEffect(() => {
    if (isOpen && modalRef.current) {
      // Initial state
      gsap.set(modalRef.current, {
        opacity: 0,
        scale: 0.8,
      })

      // Animate modal in
      gsap.to(modalRef.current, {
        opacity: 1,
        scale: 1,
        duration: 0.5,
        ease: "power3.out"
      })

      // Animate content elements
      const elements = contentRef.current.children
      gsap.fromTo(elements, 
        {
          opacity: 0,
          y: 20
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.1,
          ease: "power2.out",
          delay: 0.3
        }
      )
    }
  }, [isOpen])

  const handleClose = () => {
    gsap.to(modalRef.current, {
      opacity: 0,
      scale: 0.8,
      duration: 0.4,
      ease: "power3.in",
      onComplete: onClose
    })
  }

  if (!isOpen) return null

  // Get the connected technology names
  const connectedTechNames = getConnectedTechNames(content.connections)

  return (
    <div className={styles.modalOverlay} onClick={handleClose}>
      <div 
        ref={modalRef}
        className={styles.modalContent} 
        onClick={e => e.stopPropagation()}
      >
        <button 
          className={styles.closeButton} 
          onClick={handleClose}
          aria-label="Close modal"
        >
          ×
        </button>
        
        <div ref={contentRef}>
          <div className={styles.modalHeader}>
            <h2 className={styles.modalTitle}>{content.title}</h2>
            <div className={styles.modalCategory}>
              {content.description}
            </div>
          </div>
          
          <div className={styles.modalBody}>
            <div className={styles.modalSection}>
              <h3>Overview</h3>
              <p>{content.details}</p>
            </div>

            {connectedTechNames.length > 0 && (
              <div className={styles.modalSection}>
                <h3>Connected Technologies</h3>
                <ul className={styles.connectionsList}>
                  {connectedTechNames.map((techName, index) => (
                    <li key={index} className={styles.connectionItem}>
                      {techName}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {content.additionalContent && (
            <div className={styles.modalFooter}>
              {content.additionalContent}
            </div>
          )}
        </div>
      </div>
    </div>
  )
} 